/**
 * Builds the patch applied to a device event when one of its report inclusion flags is toggled. Sets the named field to the given value and additionally forces isIncludedStrip off when the event itself is being excluded from the report, or when the strip is being included while the event is not.
 *
 * @param name - Field being toggled on the device event.
 * @param value - New value for that field.
 * @param isIncludedToReport - Current inclusion state of the event in the report, used to veto including its strip.
 * @returns An update object holding the changed field plus any forced isIncludedStrip correction.
 */
const getUpdateValue = (name: any, value: any, isIncludedToReport: any) => {
  const updateData: any = {
    [name]: value,
  };
  if (name === 'isIncludedToReport' && !value) {
    updateData.isIncludedStrip = false;
  }
  if (name === 'isIncludedStrip' && value && !isIncludedToReport) {
    updateData.isIncludedStrip = false;
  }
  return updateData;
};

export default getUpdateValue;
